import { render, staticRenderFns } from "./configuration-option.vue?vue&type=template&id=35756f96&"
import script from "./configuration-option.vue?vue&type=script&lang=js&"
export * from "./configuration-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports